import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { Ticker } from 'app/interfaces/ticker';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StockService } from 'app/sections/stocks/services/stock.service';

@Component({
  selector: 'app-macro-ticker',
  templateUrl: './macro-ticker.component.html',
  styleUrls: ['./macro-ticker.component.scss']
})
export class MacroTickerComponent implements OnInit, OnDestroy {

  @Input('ticker') ticker: string;
  @Input('info') info: string;
  @Output() showDetails = new EventEmitter();
  public data: Ticker;
  private _unsubscribeAll: Subject<any>;

  constructor(private stockService: StockService, private cd:ChangeDetectorRef) { 
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.stockService.tickersListObservable.pipe(takeUntil(this._unsubscribeAll)).subscribe((tickers: Ticker[])=>{
      if(tickers){
        let foundIndex = tickers.map(t => t.ticker).indexOf(this.ticker);
        if(foundIndex >= 0){
          this.data = tickers[foundIndex];
          this.cd.detectChanges();
        }
      }
    });
  }

  ngOnDestroy(){
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  clicked(){
    this.showDetails.emit(this.data);
  }

}
